import { createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import ProjectDashboard from "./pages/ProjectDashboard";
import Login from "./pages/Login";
import ProjectLayout from "./pages/ProjectLayout";
import ProjectLanding from "./pages/ProjectLandingPage";
import Embedding from "./pages/Embedding";
import Umap from "./pages/Umap";
import PCA from "./pages/PCA";
import Cluster from "./pages/Cluster";
const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
        children: [{
            path: "/login",
            element: <Login />,
        },
        ],
    },
    {
        path: "/project",
        element: <ProjectLayout />,
        children:[
            {index: true, element: <ProjectDashboard /> },
            {path: "landing", element: <ProjectLanding /> },
            {path: "embedding", element: <Embedding /> },
            {path: "umap", element: <Umap /> },
            {path: "pca", element: <PCA />},
            {path: "cluster",element:<Cluster/>}
        ]
    }


]);
export default router;
